





































































































































































































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { Datetime } from 'vue-datetime';
import { api } from '@/api';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';
import moment from 'moment';

@Component({
  components: {
    FmvAvatar,
    Datetime,
    CustomSelectInput,
  },
})
export default class TaskModal extends Vue {
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public showModal: boolean;
  // @ts-ignore
  @Prop({required: false, default: null}) readonly public linkedUserId: number | null;
  public formError = false;
  public startAt = '';
  public endAt = '';
  public title = '';
  public taskType = 2;
  public linkedUser = 0;
  public linkedUsers: any = [];
  public tasksReports: any = [];
  public ticket: any = null;
  public usersToLink: any = [];
  public ticketsList: any = [];
  public description = '';
  public loadingState = {
    submit: false,
    submit_result: false,
  };
  public writeResult: boolean = false;

  public async mounted() {
    // if (this.linkedUserId) {
    //   this.linkedUser = this.linkedUserId;
    // }
    // this.getUsersToLink();
    // @ts-ignore
    this.startAt = moment(String(new Date())).format('YYYY-MM-DD');
    this.handleChangeTaskType(2);
    this.getTicketsList();
  }

  public validateForm() {
    if (
      !this.startAt || this.startAt === '' ||
      // !this.endAt || this.endAt === '' ||
      // (this.endAt && new Date() > new Date(this.endAt)) ||
      !this.title ||
      (!this.linkedUserId && this.linkedUsers.length === 0)
    ) {
      this.formError = true;
      return false;
    } else {
      this.formError = false;
      return true;
    }
  }

  public resetForm() {
    // @ts-ignore
    this.startAt = moment(String(new Date())).format('YYYY-MM-DD');
    this.endAt = '';
    this.title = '';
    this.taskType = 2;
    this.linkedUser = 0;
    this.linkedUsers = [];
    this.description = '';
    this.handleChangeTaskType(2);
    this.$emit('close-modal');
  }

  public async handleSubmit(finish: boolean = false) {
    if (await this.validateForm()) {
      try {
        let result: any = [];
        let payload: any = {
          // @ts-ignore
          performer: this.userProfile ? this.userProfile.id : 0,
          // @ts-ignore
          setted_by: this.userProfile ? this.userProfile.id : 0,
          // linked_user: this.linkedUserId ? this.linkedUserId : null,
          title: this.title,
          start_at: this.startAt,
          end_at: this.endAt,
          task_type: this.taskType,
          description: this.description,
          ticket: this.ticket,
          set_completed: finish,
        };
        if (this.linkedUserId) {
          payload['linked_user'] = this.linkedUserId;
          const response = await api.createUserTask(
            this.$store.getters.token, payload,
          );
          result.push(response.data);
        } else {
          for (let i in this.linkedUsers) {
            payload['linked_user'] = this.linkedUsers[i];
            const response = await api.createUserTask(
              this.$store.getters.token, payload,
            );
            result.push(response.data);
          }
        }
        if (finish) {
          // @ts-ignore
          this.showToast(this, this.$t('Task created'));
          this.tasksReports = result;
          this.writeResult = true;
        } else {
          // @ts-ignore
          this.showToast(this, this.$t('Task created'));
          this.$emit('task-created');
          this.resetForm();
        }
      } catch (error) {
        // @ts-ignore
        if (error.response && error.response.data) {
          let errorMsg = '';
          // @ts-ignore
          for (const [key, value] of Object.entries(error.response.data)) {
            // @ts-ignore
            errorMsg += `${this.$t(key)} - ${value[0]}\n`;
          }
          // @ts-ignore
          this.showToast(this, errorMsg, 'error');
        } else {
          // @ts-ignore
          this.showToast(this, this.$t('Error'), 'error');
        }
      }
    }
  }

  public async handleSubmitResult() {
    this.loadingState.submit_result = true;
    try {
      for (let i in this.tasksReports) {
        const response = await api.updateUserTask(
          this.$store.getters.token,
          {
            pk: this.tasksReports[i].id,
            result: this.tasksReports[i].result,
          },
        );
      }
      // @ts-ignore
      this.showToast(this, this.$t('Changes saved'));
      this.$emit('task-created');
      this.resetForm();
      this.writeResult = false;
    } catch (e) {
      // @ts-ignore
      this.showToast(this, this.$t('Error'), 'error');
    }
    this.loadingState.submit_result = false;
  }

  // public async getUsersToLink() {
  //   try {
  //     const response = await api.getUsersToLink(this.$store.getters.token);
  //     const usersToLink: any = [];
  //     for (const [key, value] of Object.entries(response.data)) {
  //       usersToLink.push({
  //         // @ts-ignore
  //         value: value[0],
  //         // @ts-ignore
  //         text: `${value[1]} ${value[2]}`,
  //       });
  //     }
  //     this.usersToLink = usersToLink;
  //   } catch (e) {
  //     this.usersToLink = [];
  //   }
  // }

  public async getTicketsList() {
    try {
      let rowQuery = '';
      this.ticket = null;
      if (this.linkedUserId) {
        rowQuery = `?user_id=${this.linkedUserId}`;
      } else if (this.linkedUsers.length === 1) {
        rowQuery = `?user_id=${this.linkedUsers[0]}`;
      } else {
        this.ticketsList = [];
        return null;
      }
      const response = await api.getTicketsChoices(this.$store.getters.token, rowQuery);
      const ticketsList: any = [];
      for (const [key, value] of Object.entries(response.data.choices)) {
        ticketsList.push({
          // @ts-ignore
          value: value[0],
          // @ts-ignore
          text: `${value[1]}`,
        });
      }
      this.ticketsList = ticketsList;
      // if ((this.linkedUsers.length === 1 || this.linkedUserId) && this.ticketsList.length > 0) {
      //   this.ticket = this.ticketsList[0].value;
      // }
    } catch (e) {
      this.ticketsList = [];
    }
  }

  public handleChangeTicket(value) {
    this.ticket = value;
  }

  public handleChangeLinkedUsers(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.linkedUsers = newList;
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public handleChangeTaskType(newType) {
    this.taskType = newType;
    let title: any = '';
    for (let i in this.taskTypes) {
      if (this.taskType === this.taskTypes[i].value) {
        title = this.taskTypes[i].text;
      }
    }
    this.title = title;
  }

  get taskTypes() {
    return [
      {
        value: 3,
        text: this.$t('Message'),
        icon: 'fas fa-envelope',
      },
      {
        value: 2,
        text: this.$t('Call'),
        icon: 'fas fa-phone',
      },
      {
        value: 1,
        text: this.$t('Meet'),
        icon: 'fas fa-handshake',
      },
      // {
      //   value: 4,
      //   text: this.$t('Gift with a letter'),
      // },
      // {
      //   value: 5,
      //   text: this.$t('Letter'),
      // },
    ];
  }

}
